import { j as s, B as t } from "./chunks/baseIcon-BOu_HqxP.js";
const l = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#314351" fill-rule="evenodd" d="M16.7071 9.04289C17.0976 9.43342 17.0976 10.0666 16.7071 10.4571L11.4571 15.7071C11.0666 16.0976 10.4334 16.0976 10.0429 15.7071L7.79289 13.4571C7.40237 13.0666 7.40237 12.4334 7.79289 12.0429C8.18342 11.6524 8.81658 11.6524 9.20711 12.0429L10.75 13.5858L15.2929 9.04289C15.6834 8.65237 16.3166 8.65237 16.7071 9.04289Z" clip-rule="evenodd"/></svg>';
function n(e) {
  return /* @__PURE__ */ s.jsx(t, { svg: l, ...e });
}
n.displayName = "SpecialStatusCheck";
export {
  n as default
};
